import { AlertTriangle, RefreshCw, ArrowLeft, Clock, XCircle } from "lucide-react";
import { Button } from "./ui/button";

// Terminal states: failed (incl. timed out) and cancelled, with Back / Retry.
export const BuildFailedPanel = ({ creation, onRetry, onBack }) => {
  const cancelled = creation.build_status === "cancelled";
  const timedOut = !cancelled && /timed out/i.test(creation.build_error || "");
  const gaveUp = /could not sculpt this duck/i.test(creation.build_error || "");
  const Icon = cancelled ? XCircle : timedOut ? Clock : AlertTriangle;
  const cap = creation.max_sculpt_submissions;
  return (
    <>
      <span
        data-testid="build-status-badge"
        className={`inline-flex items-center gap-2 rounded-full text-xs font-mono2 uppercase tracking-widest px-3 py-1 ${
          cancelled ? "bg-muted text-muted-foreground" : "bg-destructive/10 text-destructive"
        }`}
      >
        <Icon className="h-3.5 w-3.5" />
        {cancelled ? "Build cancelled" : timedOut ? "Build timed out" : "Build failed"}
      </span>
      <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">
        {cancelled ? "You stopped this build" : timedOut ? "The sculptor took longer than 15 minutes" : "We couldn't sculpt this one"}
      </h2>
      <p data-testid="build-error" className="text-muted-foreground">{creation.build_error || "Unknown error."}</p>
      {!cancelled && !gaveUp && (
        <p data-testid="stronger-note" className="text-xs text-muted-foreground font-mono2">
          Next attempt uses Hyper3D Rodin (high quality, all four views) before falling back to Hunyuan Pro.
          {cap ? ` A build makes at most ${cap} paid sculpt ${cap === 1 ? "try" : "tries"}.` : ""}
        </p>
      )}
      {gaveUp && (
        <p data-testid="gave-up-note" className="text-xs text-muted-foreground font-mono2">
          We've stopped trying on our own{cap ? ` after ${cap} paid sculpt ${cap === 1 ? "try" : "tries"}` : ""} — nothing is running and nothing more will be charged.
        </p>
      )}
      <div className="flex gap-3">
        <Button variant="outline" className="rounded-full h-12 gap-2" onClick={onBack} data-testid="build-back-btn">
          <ArrowLeft className="h-4 w-4" /> Back to render
        </Button>
        <Button className="rounded-full h-12 gap-2 font-bold flex-1" onClick={onRetry} data-testid="build-retry-btn">
          <RefreshCw className="h-4 w-4" /> Retry with a stronger sculptor
        </Button>
      </div>
    </>
  );
};
